function initGalleries(root = document) {
  root.querySelectorAll('[data-styloria-gallery]').forEach((gal) => {
    if (gal.dataset.galleryReady === '1') return;
    gal.dataset.galleryReady = '1';

    const track = gal.querySelector('[data-gallery-track]');
    const slides = Array.from(gal.querySelectorAll('[data-slide]'));
    const dots = Array.from(gal.querySelectorAll('[data-gallery-dot]'));
    const prev = gal.querySelector('[data-gallery-prev]');
    const next = gal.querySelector('[data-gallery-next]');
    if (!track || slides.length === 0) return;

    let index = 0;
    let startX = 0;
    let deltaX = 0;
    let dragging = false;

    const goTo = (i) => {
      index = (i + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
    };

    prev?.addEventListener('click', () => goTo(index - 1));
    next?.addEventListener('click', () => goTo(index + 1));
    dots.forEach((dot) => {
      dot.addEventListener('click', () => goTo(Number(dot.dataset.galleryDot) || 0));
    });

    const onStart = (x) => {
      dragging = true;
      startX = x;
      deltaX = 0;
      track.style.transition = 'none';
    };
    const onMove = (x) => {
      if (!dragging) return;
      deltaX = x - startX;
      const pct = (deltaX / track.clientWidth) * 100;
      track.style.transform = `translateX(calc(-${index * 100}% + ${pct}%))`;
    };
    const onEnd = () => {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      if (Math.abs(deltaX) > track.clientWidth * 0.2) {
        goTo(deltaX < 0 ? index + 1 : index - 1);
      } else {
        goTo(index);
      }
    };

    track.addEventListener('touchstart', (e) => onStart(e.touches[0].clientX), { passive: true });
    track.addEventListener('touchmove', (e) => onMove(e.touches[0].clientX), { passive: true });
    track.addEventListener('touchend', onEnd);
    track.addEventListener('mousedown', (e) => {
      e.preventDefault();
      onStart(e.clientX);
    });
    window.addEventListener('mousemove', (e) => onMove(e.clientX));
    window.addEventListener('mouseup', onEnd);

    goTo(0);
  });
}

function initShareButtons(root = document) {
  root.querySelectorAll('[data-styloria-share]').forEach((btn) => {
    if (btn.dataset.shareReady === '1') return;
    btn.dataset.shareReady = '1';
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      e.stopPropagation();
      const url = btn.dataset.shareUrl || window.location.href;
      const title = btn.dataset.shareTitle || document.title;
      try {
        if (navigator.share) {
          await navigator.share({ url, title });
          return;
        }
      } catch (_) {
        /* user cancelled or unsupported path → copy */
      }
      try {
        await navigator.clipboard.writeText(url);
        const prev = btn.getAttribute('aria-label');
        btn.setAttribute('aria-label', 'Copied');
        setTimeout(() => btn.setAttribute('aria-label', prev || 'Share'), 1600);
      } catch (_) {
        window.prompt('Copy link', url);
      }
    });
  });
}

function initShopRailAdSetLinks(root = document) {
  root.querySelectorAll('.styloria-shop-rail__label').forEach((el) => {
    if ((el.textContent || '').trim() !== 'Ad Set') return;
    const link = el.closest('a.styloria-shop-rail__link');
    if (link) link.setAttribute('href', '/collections/ad-set');
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initGalleries();
  initShareButtons();
  initShopRailAdSetLinks();
});
export { initGalleries, initShareButtons, initShopRailAdSetLinks };
